import { useMemo, useState } from 'react';
import { connect } from 'react-redux';
import {
  GridLegacy as Grid,
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  DialogContent,
  TextField,
} from '@mui/material';
import EquipmentDetailBox from '../EquipmentDetailBox';
import { locationEquipmentNameValid } from '../../../../redux/constants/names';

const EditEquipmentDialog = ({ open, onSubmit, onClose, equip, allNames, loaded }) => {
  const [equipName, setEquipName] = useState();

  const handleClose = () => {
    onClose();
    setEquipName();
  };

  const newEquipment = useMemo(() => !equip || !equip?.equip_id, [equip]);
  const allOtherNames = useMemo(
    () => allNames.filter((name) => name !== equip?.name),
    [allNames, equip]
  );

  const handleSubmit = () => {
    const edittedEquipment = { ...(equip || {}), new_name: equipName };
    onSubmit(edittedEquipment);
    handleClose();
  };

  const disabled = !loaded || !locationEquipmentNameValid(equipName, allOtherNames);
  return (
    <Dialog open={open} maxWidth="md" fullWidth>
      <DialogTitle>{newEquipment ? 'New Equipment' : 'Edit Equipment'}</DialogTitle>
      <DialogContent>
        {!newEquipment ? <EquipmentDetailBox equip={equip} /> : null}
        <Grid container item xs={12} direction="column">
          <TextField
            helperText={
              <>
                Please enter equipment name.
                <br />
                Name must only contain letters, numbers, spaces, and these special characters:
                .\+#:_,()&&apos;&quot;-
                <br />
                Published Equipment names must be unique within a building and cannot share a name
                with a Location. This check is enforced when equipment are published
              </>
            }
            label="Name"
            value={equipName ?? equip?.name ?? ''}
            onChange={(event) => setEquipName(event.target.value)}
          />
        </Grid>
      </DialogContent>
      <DialogActions style={{ justifyContent: 'space-between' }}>
        <Button variant="contained" onClick={handleSubmit} color="success" disabled={disabled}>
          Save
        </Button>
        <Button variant="contained" onClick={handleClose} color="error" disabled={!loaded}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = (state, { buildingId }) => {
  const {
    entities: {
      staging: { loaded, pointsByBuilding, equipmentByBuilding },
    },
  } = state;

  // Including filtered point as points
  return {
    loaded: loaded[buildingId ?? ''] ?? false,
    pointsByTopic: pointsByBuilding[buildingId ?? ''] ?? {},
    allEquipment: equipmentByBuilding[buildingId ?? ''] ?? [],
  };
};

export default connect(mapStateToProps)(EditEquipmentDialog);
